import moment from 'moment';

import type { Moment } from 'moment';

/**
 * Checks if a day is blocked
 * @param day The day to check
 * @param availableDates The available dates
 * @returns If the day is blocked
 */
export const isDayBlocked = (
  day: Moment,
  availableDates: {
    desde: number;
    hasta: number;
  }[]
) => {
  for (const d of availableDates) {
    if (
      day.isBetween(moment(d.desde * 1000), moment(d.hasta * 1000), 'day', '[]')
    ) {
      return false;
    }
  }

  return true;
};

/**
 * Checks if a day is highlighted
 * @param day The day to check
 * @param availableDates The available dates
 * @returns If the day is highlighted
 */
export const isDayHighlighted = (
  day: Moment,
  availableDates: {
    desde: number;
    hasta: number;
  }[]
) => {
  for (const d of availableDates) {
    if (
      day.isBetween(moment(d.desde * 1000), moment(d.hasta * 1000), 'day', '[]')
    ) {
      return true;
    }
  }

  return false;
};
